import { Component, OnInit } from '@angular/core';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';

@Component({
  selector: 'app-channelpartner',
  templateUrl: './channelpartner.component.html',
  styleUrls: ['./channelpartner.component.css']
})
export class ChannelPartnerComponent implements OnInit {

  Submitted: boolean = false;
  School: any;
  InstitutionType: any;
  Country: any;
  State: any;
  PartnerType: any;
  City: any;
  SelectedFileForUpload: any;
  PartnerList: any;

  constructor(private superadminservice: SuperadminService, private lookupservice: LookupService, 
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  PartnerModel = {
    LogoPath: '',
    PartnerID: 0,
    SchoolID: 0,
    PartnerName: '',
    PartnerCode: '',
    OwnerName: '',
    Phone: '',
    AffiliationFrom: '',
    ContactNo: '',
    ContactPerson: '',
    IsActive: true,
    AffiliationNo: '',
    CityID: 0,
    StateID: 0,
    CountryID: 0,
    ZipCode: '',
    Address: '',
    StaffName: '',
    UserID: '',
    Password: '',
    PartnerTypeID: 0,
    Email: '',
    Fax: '',
    DiscountPer:0,
    EarningPer:0,
    AccountHolderName:'',
    AccountNo:'',
    BankName:'',
    IFSCCode:'',
  };

  Clear() {
    this.PartnerModel.LogoPath = '';
    this.PartnerModel.PartnerID = 0;
    this.PartnerModel.PartnerName = '';
    this.PartnerModel.OwnerName = '';
    this.PartnerModel.Phone = '';
    this.PartnerModel.AffiliationFrom = '';
    this.PartnerModel.ContactNo = '';
    this.PartnerModel.ContactPerson = '';
    this.PartnerModel.IsActive = false;
    this.PartnerModel.CityID = 0;
    this.PartnerModel.CountryID = 0;
    this.PartnerModel.StateID = 0;
    this.PartnerModel.ZipCode = '';
    this.PartnerModel.Address = '';
    this.PartnerModel.Email = '';
    this.PartnerModel.Fax = '';
    this.Submitted = false;
    this.PartnerModel.UserID = '';
    this.PartnerModel.Password = '';
    this.PartnerModel.DiscountPer = 0;
    this.PartnerModel.EarningPer = 0;
    this.PartnerModel.AccountHolderName='';
    this.PartnerModel.AccountNo='';
    this.PartnerModel.BankName='';
    this.PartnerModel.IFSCCode='';

  };


  BindPartner() {
    this.spinnerService.show();
    this.superadminservice.BindPartner().subscribe((response: any) => {
      this.PartnerList = response.PartnerList;
      this.spinnerService.hide();

    });
  };

  PartnerMarkActive(obj) {
    this.Clear();
    this.PartnerModel.PartnerID = obj.PartnerID;
    this.PartnerModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.superadminservice.PartnerMarkActive(JSON.stringify(this.PartnerModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.BindPartner();
      this.globalHelper.CheckActionStatus(response);

    });
  }

  validationPartnerDropDown() {
    return this.PartnerModel.CountryID == 0 || this.PartnerModel.StateID == 0, this.PartnerModel.CityID == 0;
  }

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };


  SavePartner(valid) {

    this.Submitted = true;
    if (valid && !this.validationPartnerDropDown()) {
      this.spinnerService.show();

      this.superadminservice.SavePartner(JSON.stringify(this.PartnerModel), (this.SelectedFileForUpload)).subscribe((response: any) => {

        if (response.webResponse.Status && this.PartnerModel.PartnerID == 0) {
          this.Clear();

        }
        if (response.webResponse.Status) {
          this.BindPartner();
        }
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response)
      });
    }
  };


  PartnerEdit(obj) {
    this.PartnerModel.PartnerID = obj.PartnerID;
    this.PartnerModel.PartnerName = obj.PartnerName;
    this.PartnerModel.ContactNo = obj.ContactNo;
    this.PartnerModel.ContactPerson = obj.ContactPerson;
    this.PartnerModel.IsActive = obj.IsActive;
    this.PartnerModel.Phone = obj.Phone;
    this.PartnerModel.CountryID = obj.CountryID;
    this.GetPartnerState();
    this.PartnerModel.StateID = obj.StateID;
    this.GetPartnerCity();
    this.PartnerModel.CityID = obj.CityID;
    this.PartnerModel.ZipCode = obj.ZipCode;
    this.PartnerModel.Address = obj.Address;
    this.PartnerModel.Fax = obj.Fax;
    this.PartnerModel.Email = obj.Email;
    this.PartnerModel.UserID = obj.UserID;
    this.PartnerModel.Password = obj.Password;
    this.PartnerModel.DiscountPer = obj.DiscountPer;
    this.PartnerModel.EarningPer = obj.EarningPer;
    this.PartnerModel.AccountHolderName=obj.AccountHolderName;
    this.PartnerModel.AccountNo=obj.AccountNo;
    this.PartnerModel.BankName=obj.BankName;
    this.PartnerModel.IFSCCode=obj.IFSCCode;
  };

  ngOnInit() {
    this.GetPartnerSchool();
    this.GetPartnerType();
    this.GetPartnerInstitutionType();
    this.GetBindCountry();
    this.BindPartner();



  }

  GetPartnerSchool() {

    this.lookupservice.GetLookupsList('School', '').subscribe((data: any) => {
      this.School = data.LookupItems;
    });

  }

  GetPartnerInstitutionType() {
    this.lookupservice.GetLookupsList('InstitutionType', '').subscribe((data: any) => {
      this.InstitutionType = data.LookupItems;
    });
  };

  GetBindCountry() {
    this.lookupservice.GetLookupsList('Country', '').subscribe((data: any) => {
      this.Country = data.LookupItems;
    });
  };


  GetPartnerState() {
    var Itembo = {
      'ItemId': this.PartnerModel.CountryID
    }
    this.lookupservice.GetLookupsList('State', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.State = data.LookupItems;
    });
  };

  GetPartnerType() {

    this.lookupservice.GetLookupsList('Partner', '').subscribe((data: any) => {
      this.PartnerType = data.LookupItems;
    });
  };

  GetPartnerCity() {
    var Itembo = {
      'ItemId': this.PartnerModel.StateID
    }
    this.lookupservice.GetLookupsList('City', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.City = data.LookupItems;
    });
  };

}

